





import { mapActions } from 'vuex'
import { initStoreModule } from '@/utils/helpers/storeHelpers'
import { storeModuleName, store } from '@/views/App/Deal/store'

export default initStoreModule(storeModuleName, store).extend({
  name: 'MainAppPage',
  methods: {
    ...mapActions(storeModuleName, ['getDeal'])
  },
  created () {
    this.getDeal()
  }
})
